import { CreatePersonForm } from '~/pages/person/components/create-person-form';
import { Schema } from '~/pages/person/components/create-person-form.schema';
import { useCreatePersonMutation } from '~/pages/person/mutations';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';

export const Page = withPrivateRoute(() => {
  const mutation = useCreatePersonMutation();
  const navigate = useNavigate();

  async function handleSubmit(payload: Partial<Schema>) {
    const { data } = await mutation.mutateAsync({
      first_name: payload.first_name!,
      last_name: payload.last_name!,
      club: payload.club!,
      ssn: payload.ssn!,
      is_para: payload.is_para!,
      is_ifn: payload.is_ifn!,
    });

    navigate(`../${data.id}`);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa lyftare" />

      <PageLayout.Section>
        <CreatePersonForm onSubmit={handleSubmit} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
});
